export default {"src":"/_next/static/media/0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};